var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3824_10012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33398 8.66675L4.85696 9.71268C5.03395 10.0667 5.12244 10.2437 5.24067 10.397C5.34558 10.5331 5.46759 10.6551 5.60368 10.7601C5.75706 10.8783 5.93405 10.9668 6.28804 11.1437L7.33398 11.6667L6.28804 12.1897C5.93405 12.3667 5.75706 12.4552 5.60368 12.5734C5.46759 12.6783 5.34558 12.8003 5.24067 12.9365C5.12244 13.0898 5.03395 13.2668 4.85696 13.6208L4.33398 14.6667L3.81101 13.6208C3.63402 13.2668 3.54552 13.0898 3.4273 12.9365C3.32239 12.8003 3.20038 12.6783 3.06428 12.5734C2.9109 12.4552 2.73392 12.3667 2.37993 12.1897L1.33398 11.6667L2.37993 11.1437C2.73392 10.9668 2.9109 10.8783 3.06428 10.7601C3.20038 10.6551 3.32239 10.5331 3.4273 10.397C3.54552 10.2437 3.63402 10.0667 3.81101 9.71268L4.33398 8.66675Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 1.33325L10.7864 3.3762C10.9744 3.86502 11.0684 4.10943 11.2146 4.31501C11.3442 4.49722 11.5033 4.65642 11.6856 4.78598C11.8911 4.93216 12.1356 5.02617 12.6244 5.21417L14.6673 5.99992L12.6244 6.78565C12.1356 6.97365 11.8911 7.06765 11.6856 7.21385C11.5033 7.34345 11.3442 7.50258 11.2146 7.68485C11.0684 7.89038 10.9744 8.13485 10.7864 8.62365L10.0007 10.6666L9.21492 8.62365C9.02692 8.13485 8.93292 7.89038 8.78672 7.68485C8.65712 7.50258 8.49798 7.34345 8.31572 7.21385C8.11018 7.06765 7.86572 6.97365 7.37692 6.78565L5.33398 5.99992L7.37692 5.21417C7.86572 5.02617 8.11018 4.93216 8.31572 4.78598C8.49798 4.65642 8.65712 4.49722 8.78672 4.31501C8.93292 4.10943 9.02692 3.86502 9.21492 3.3762L10.0007 1.33325Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3824_10012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsWhite);
export default __webpack_public_path__ + "static/media/stars_white.b647072a382ce6ca03a104f4cf31ef0a.svg";
export { ForwardRef as ReactComponent };